// PatternPresets.js - Common regex patterns for form validation

/**
 * Common regex pattern presets for input validation
 */
export const patternPresets = {
    // Email address pattern
    email: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',

    // International phone number pattern
    phone: '^\\+?[1-9][0-9]{1,14}$',

    // URL pattern
    url: '^(https?:\\/\\/)?([\\da-z.-]+)\\.([a-z.]{2,6})([\\/?\\w .-]*)*\\/?$',

    // US ZIP code pattern (5 digits or 5+4)
    zipCode: '^\\d{5}(-\\d{4})?$',

    // ISO date format (YYYY-MM-DD)
    date: '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$',

    // Time format (HH:MM or HH:MM:SS, 24-hour)
    time: '^([01]?[0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$',

    // IPv4 address pattern
    ipAddress: '^(?:[0-9]{1,3}\\.){3}[0-9]{1,3}$'
};

/**
 * Get a pattern by key
 * @param {string} key - The pattern key
 * @returns {string} The regex pattern or empty string if not found
 */
export const getPattern = (key) => {
    return patternPresets[key] || '';
};

/**
 * Get all available pattern preset options
 * @returns {Array} Array of preset option objects with value and label properties
 */
export const getPatternOptions = () => {
    return [
        { value: 'email', label: 'Email' },
        { value: 'phone', label: 'Phone' },
        { value: 'url', label: 'URL' },
        { value: 'zipCode', label: 'Zip Code' },
        { value: 'date', label: 'Date (YYYY-MM-DD)' },
        { value: 'time', label: 'Time (HH:MM)' },
        { value: 'ipAddress', label: 'IP Address' }
    ];
};

export default patternPresets;
